import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import type { ChatMessageData } from '@/pages/ChatbotPage'

interface ChatMessageProps {
  message: ChatMessageData
  onSave?: () => void
}

export function ChatMessage({ message, onSave }: ChatMessageProps) {
  const isUser = message.role === 'user'

  return (
    <div className={`flex items-start gap-3 ${isUser ? 'flex-row-reverse' : ''}`}>
      {/* Avatar */}
      <span className="text-lg flex-shrink-0">
        {isUser ? '👤' : '🤖'}
      </span>

      {/* Message bubble */}
      <div className={`${isUser ? 'max-w-[75%] items-end' : 'max-w-full flex-1 items-start'}`}>
        {/* Data warnings (subtask 13.9) */}
        {!isUser && message.dataWarnings && message.dataWarnings.length > 0 && (
          <div className="mb-2 space-y-1">
            {message.dataWarnings.map((warning, idx) => (
              <div
                key={idx}
                className="flex items-center gap-2 px-3 py-1.5 rounded text-xs bg-amber-500/10 border border-amber-500/30 text-amber-400"
              >
                <span>⚠️</span>
                <span>{warning}</span>
              </div>
            ))}
          </div>
        )}

        {/* Message content */}
        <div
          className={`rounded-lg px-4 py-3 text-sm ${
            isUser
              ? 'bg-[var(--color-accent)] text-white'
              : 'bg-[var(--color-bg-tertiary)] text-[var(--color-text-primary)]'
          }`}
        >
          {isUser ? (
            <p className="whitespace-pre-wrap">{message.content}</p>
          ) : (
            <div className="report-content">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{message.content}</ReactMarkdown>
            </div>
          )}
        </div>

        {/* Timestamp + Save button */}
        <div className="flex items-center gap-2 mt-1 px-1">
          <span className="text-[10px] text-[var(--color-text-muted)]">
            {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </span>
          {!isUser && onSave && (
            <button
              onClick={onSave}
              className="px-2 py-0.5 text-[10px] rounded border border-[var(--color-accent)] text-[var(--color-accent)] hover:bg-[var(--color-accent)] hover:text-white transition-colors flex-shrink-0"
            >
              💾 Save as Report
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
